import { render, staticRenderFns } from "./ComplexCustomers.vue?vue&type=template&id=0625efc9&scoped=true"
import script from "./ComplexCustomers.vue?vue&type=script&lang=js"
export * from "./ComplexCustomers.vue?vue&type=script&lang=js"
import style0 from "./ComplexCustomers.vue?vue&type=style&index=0&id=0625efc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0625efc9",
  null
  
)

export default component.exports